var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateModal',{ref:"modal",attrs:{"edit":!_vm.create,"text":_vm.text,"send-function":_vm.onSave,"open-function":_vm.onOpen,"minimalize":_vm.minimalize}},[_c('BaseInput',{attrs:{"label":_vm.localStorage.translations.pages['setting-work_extra_type']['dialog-add_edit-labels'][
        'nazvanie'
      ],"prepend-inner-icon":"mdi-wrench","rules":['required', 'max100'],"placeholder":_vm.localStorage.translations.pages['setting-work_extra_type']['dialog-add_edit-labels'][
        'nazvanie'
      ]},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }